import { render, staticRenderFns } from "./LocalOrderReviewDialog.vue?vue&type=template&id=2c717bc8&"
import script from "./LocalOrderReviewDialog.vue?vue&type=script&lang=js&"
export * from "./LocalOrderReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports